import Grid from '@mui/material/Grid2'
import { FC, useEffect } from 'react'
import { APP_TOP_INDENT, APP_TOP_INDENT_MOBILE } from '../../../constants/app.indents'
import { useUserStore } from '../../../store/storeUser'
import { RemoveAccount } from './components/RemoveAccount'
import { TelegramAccountNotifications } from './components/TelegramAccountNotifications'
import { UserData } from './components/UserData'
import { UserPersonalData } from './components/UserPersonalData'
import { useMediaQuery } from '@mui/material'
import { theme } from '../../../theme'

export const ProfilePage: FC = () => {
    const { getUserPersonalData } = useUserStore((state) => state)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    useEffect(() => {
        getUserPersonalData()
    }, [])

    return (
        <Grid
            spacing={3}
            style={{ overflow: 'auto', height: `calc(100dvh - ${isMobile ? APP_TOP_INDENT_MOBILE : APP_TOP_INDENT}px)` }}>
            <UserPersonalData />
            <TelegramAccountNotifications />
            <UserData />
            <RemoveAccount />
        </Grid>
    )
}
